module.exports = __webpack_public_path__ + "img/folder.dd6c1eb1.png";